import { UseFormReset } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Form, FormField } from 'core/components';
import { InputType } from 'core/enums';
import { ICostDiscountForm } from 'quotes/types';

interface IProps {
  isOpen?: boolean;
  onClose?: (reset: UseFormReset<ICostDiscountForm>, closeSelection?: boolean) => void;
  onSubmit?: (reset?: UseFormReset<ICostDiscountForm>) => (data: ICostDiscountForm) => void;
}

const QuotePartCostDiscountFormView = ({ isOpen = false, onClose, onSubmit }: IProps) => {
  const { t } = useTranslation();

  return (
    <Form
      title={t('titleApplyCostDiscount')}
      isOpen={isOpen}
      onClose={onClose}
      submitBtnLabel={t('buttonLabelApplyCostDiscount')}
      cancelBtnLabel={t('buttonLabelCancel')}
      onSubmit={onSubmit}
    >
      <FormField
        name="discount"
        type={InputType.NUMBER_INPUT}
        inputProps={{
          label: t('labelCostDiscount'),
          required: true,
          slotProps: {
            input: {
              min: 0,
              max: 100,
              allowedDecimalSeparators: [],
              decimalScale: 2,
              suffix: '%',
            },
          },
        }}
      />
    </Form>
  );
};

export default QuotePartCostDiscountFormView;
